module.exports = __webpack_public_path__ + "static/media/generalCard3.f41a1ae5.svg";